




























































































































import { Component, Vue, Ref, Prop, Emit, Watch } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import { Inject } from '@cds/common';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';

@Component({
  components: {}
})
export default class KPISubFolderAdd extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;
  @Ref('subFolderForm') private subFolderForm!: ElForm;

  @Prop() private folderId!: Number;
  @Watch('folderId', { immediate: true, deep: true })
  public onChangeFolderId(newVal: any, oldVal: any) {
    console.log('folderId watch', newVal)
    if (typeof newVal === 'number') {
      this.fetchSubFolderList();
    } else {
      this.mainFolderInfo = {
        id: undefined,
        name: '',
        postLevel: '全部',
        createdTime: '',
        kpiFolderVOList: [],
      }
      this.subFolderList = [];
      this.postLevelOptions = [];
    }
  }

  @Emit('saved') // 父级接收事件名
  private async emitSaved(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Emit('cancel') // 父级接收事件名
  private async emitClose(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  public mainFolderInfo = {
    id: undefined,
    name: '',
    postLevel: '全部',
    createdTime: '',
    kpiFolderVOList: [],
  }

  // 子目录列表
  public subFolderList: any[] = [];

  // 子目录post Level下拉选项
  public postLevelOptions: string[] = [];

  // 加载状态
  public loading: boolean = false;

  // 获取子目录列表
  private async fetchSubFolderList(): Promise<void> {
    this.loading = true;
    try {
      const res = await this.nuoxiaoerService.fetchKpiFolderChildList({ id: this.folderId });
      this.loading = false;
      console.log('子目录接口返回', res);
      if (res) {
        const { id, name, postLevel, createdTime, kpiFolderVOList, } = res || { id:null, name:'', postLevel:'', createdTime:'', kpiFolderVOList:[] };
        this.mainFolderInfo = res || {};
        const postLevelOps = this.getAvailablePostLevels(postLevel);
        // 更新子目录列表
        const list = (kpiFolderVOList || []).map((x: any) => {
          return {
            id: x.id,
            groupId: x.groupId,
            name: x.name,
            nameEn: x.nameEn,
            postLevel: x.postLevel || postLevel,
            remarks: x.remarks || '',
            label: x.label !== undefined ? x.label : 'incentive', // 只有在值为undefined时才使用默认值
            sortNumber: x.sortNumber || 0,
            createdTime: x.createdTime,
          };
        }).sort((a, b) => a.sortNumber - b.sortNumber);

        this.postLevelOptions = postLevelOps;
        this.subFolderList = list;
      }
    } catch (error) {
      this.loading = false;
      console.error('获取子目录列表失败：', error);
      this.$message.error('获取子目录列表失败，请刷新重试');
    }
  }

  // 添加子目录
  public addSubFolder(): void {
    // 计算新的排序号（当前最大排序号+1）
    let maxSortNumber = 0;
    if (this.subFolderList.length > 0) {
      this.subFolderList.forEach(item => {
        if (item.sortNumber && item.sortNumber > maxSortNumber) {
          maxSortNumber = item.sortNumber;
        }
      });
    }

    const newSubFolder = {
      id: '',
      groupId: this.folderId,
      name: '',
      nameEn: '',
      postLevel: this.mainFolderInfo.postLevel,
      remarks: '',
      label: 'incentive', // 默认值
      sortNumber: maxSortNumber + 1,
      createdTime: null
    };

    this.subFolderList.push(newSubFolder);
  }

  // 删除子目录
  public async removeSubFolder(index: number): Promise<void> {
    const subFolder = this.subFolderList[index];
    
    // 如果是已保存的子目录（有id），需要检查是否有关联内容
    if (subFolder.id) {
      try {
        const hasRelatedContent = await this.nuoxiaoerService.fetchKpiFolderRelationContent({ folderId: subFolder.id });
        console.log('hasRelatedContent',hasRelatedContent)
        if (hasRelatedContent) {
          this.$message({
            message: '该子目录下有关联考核项，无法删除！',
            type: 'warning'
          });
          return;
        }
      } catch (error) {
        console.error('检查子目录关联内容失败：', error);
        this.$message.error('检查子目录关联内容失败，请重试');
        return;
      }
    }

    try {
      // 确认删除
      await this.$confirm('确定要删除该子目录吗？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });

      this.subFolderList.splice(index, 1);
    } catch (error) {
      // 用户取消删除操作
      console.log('取消删除');
    }
  }

  // 获取可选的Post Level选项
  public getAvailablePostLevels(postLevel: string): string[] {
    if (postLevel === '全部') {
      return ['全部', 'MR', 'DM'];
    }
    if (postLevel === 'MR') {
      return ['MR'];
    }
    if (postLevel === 'DM') {
      return ['DM'];
    }
    return ['全部'];
  }

  // 提交表单
  public async submitForm(): Promise<void> {
    // 验证表单
    if (!this.validateForm()) {
      return;
    }

    try {
      // 确认保存
      await this.$confirm('是否确认保存并发布？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'info'
      });

      // 构建提交数据
      const submitData: any = {
        id: this.mainFolderInfo.id,
        groupId: this.mainFolderInfo.id,
        name: this.mainFolderInfo.name,
        postLevel: this.mainFolderInfo.postLevel,
        kpiFolderVOList: this.subFolderList.map(item => {
          return {
            id: item.id || null,
            groupId: this.folderId,
            name: item.name,
            nameEn: item.nameEn,
            postLevel: item.postLevel,
            remarks: item.remarks,
            label: item.label, // 直接使用输入的值，不设置默认值
            sortNumber: item.sortNumber,
            createdTime: item.createdTime
          };
        })
      };

      console.log('提交数据:', submitData);

      // 保存数据
      await this.nuoxiaoerService.saveKpiSubFolder(submitData);

      this.$message({
        message: '保存成功',
        type: 'success'
      });

      this.emitSaved();
    } catch (error) {
      if (error === 'cancel') {
        // 用户取消操作，不做处理
        return;
      }
      console.error('保存失败：', error);
      this.$message.error('保存失败：' + (error.message || '未知错误'));
    }
  }

  // 验证表单
  private validateForm(): boolean {
    // this.$refs['subFolderForm'].validate((valid) => {
    this.subFolderForm.validate((valid, info) => {
      console.log('表单校验：', valid, info);
    });
    // 验证子目录列表
    // if (this.subFolderList.length === 0) {
    //   this.$message.error('请至少添加一个子目录');
    //   return false;
    // }

    // 验证每个子目录的必填项
    for (let i = 0; i < this.subFolderList.length; i++) {
      const folder = this.subFolderList[i];

      if (!folder.name) {
        this.$message.error(`第${i + 1}行子目录中文名称不能为空`);
        return false;
      }

      if (!folder.nameEn) {
        this.$message.error(`第${i + 1}行子目录英文名称不能为空`);
        return false;
      }

      // if (!(/^[a-zA-Z]+$/).test(folder.nameEn)) {
      //   this.$message.error(`第${i + 1}行子目录英文名称只允许输入大小写字母`);
      //   return false;
      // }

      if (!folder.sortNumber && folder.sortNumber !== 0) {
        this.$message.error(`第${i + 1}行顺序号不能为空`);
        return false;
      }
    }

    // 检查是否有重复的顺序号
    const sortNumbers = this.subFolderList.map(item => item.sortNumber);
    const uniqueSortNumbers = new Set(sortNumbers);
    if (sortNumbers.length !== uniqueSortNumbers.size) {
      this.$message.error('存在重复的顺序号，请修改');
      return false;
    }

    return true;
  }

  // 取消按钮
  public async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否关闭当前界面？关闭后，当前界面内容将会丢失', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitClose();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }

  private validateOnlyEn(rule, value, callback): void {
    const isOk = (/^[a-zA-Z]+$/).test(value);
    if (!value) {
      callback(new Error('请输入英文名称'));
    }
    if (!isOk) {
      callback(new Error('只允许输入大小写字母'));
    } else {
      callback();
    }
  }

}
